import { inject } from '@angular/core';
import { filter, firstValueFrom, take } from 'rxjs';
import { USER_DATA_TOKEN, UserDataProvider, UserModel } from '@core';
import { IntroductionV2Service } from '@introduction/infra';
import { IntroductionCompletionReason } from '../models';

export class CompleteIntroductionCommandHandler {
  private readonly introductionV2Service: IntroductionV2Service = inject(IntroductionV2Service);
  private readonly userDataProvider: UserDataProvider = inject(USER_DATA_TOKEN);

  async complete(reason: IntroductionCompletionReason, lastSlideIndex: number): Promise<void> {
    const userData: UserModel = await firstValueFrom(
      this.userDataProvider.userData$.pipe(
        filter((data: UserModel) => !!data?.userId),
        take(1)
      )
    );

    return this.introductionV2Service.complete(userData.userId, {
      completedAt: new Date().toISOString(),
      reason,
      lastSlideIndex
    });
  }
}
